import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesFinalInstructionsClientV2Component, SalesFinalInstructionsClientV3Component} from "./versions/sales-final-instructions-client-versions.component";
import {SalesFinalInstructionsClientComponent} from "./sales-final-instructions-client.component";
import {StoreV2IconComponent} from "../../shared/resources/store-v2-icon/store-v2-icon.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {GeneralModule} from "../general/general.module";
import {QRCodeModule} from "angularx-qrcode";



@NgModule({
  declarations: [
    SalesFinalInstructionsClientV2Component,
    SalesFinalInstructionsClientV3Component,
    SalesFinalInstructionsClientComponent,
    StoreV2IconComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    GeneralModule,
    QRCodeModule
  ],
  exports: [
    SalesFinalInstructionsClientComponent,
    StoreV2IconComponent
  ]
})
export class SalesFinalInstructionsClientModule { }
